import { render, staticRenderFns } from "./Input-Description-Edit.vue?vue&type=template&id=33ba7088&lang=pug"
import script from "./Input-Description-Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Input-Description-Edit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports